import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { timeout: Number }

  connect() {
    if (this.hasTimeoutValue) {
      this.timeoutId = setTimeout(() => this.close(), this.timeoutValue)
    }
  }

  disconnect() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId)
    }
  }

  close() {
    this.element.classList.add("opacity-0", "translate-y-2", "transition")
    setTimeout(() => this.element.remove(), 200)
  }
}
